module.exports = __webpack_public_path__ + "media/application/images/ui/plus-minus-b489224ea8700ad09a6bb0f250911e87.png";